import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import PieChartLegendTable from './PieChartLegend/PieChartLegendTable';
import Box from '@mui/material/Box';
import { useState } from 'react';
import './PieChart.css';
import { Typography } from '@mui/material';

export default function PieChart(props: any) {
  const [currentSelectedSpecies, setCurrentSelectedSpecies] =
    useState<String>('');

  function highlightData(species: string) {
    setCurrentSelectedSpecies(species);
  }
  if (!props.rows || props.rows.length === 0) {
    return <Typography sx={{ p: 4 }}>No Species Detected</Typography>;
  }
  const speciesList = props.rows.map((obj: any) => obj.species).slice(0, 7);
  const speciesPercentage = props.rows
    .map((obj: any) => obj.percentage)
    .slice(0, 7);
  const options: ApexOptions = {
    chart: {
      type: 'pie',
      events: {
        dataPointMouseEnter: function (event, chartContext, config) {
          highlightData(config.w.globals.seriesNames[config.dataPointIndex]);
        },
        dataPointMouseLeave: function (event, chartContext, config) {
          setCurrentSelectedSpecies('');
        },
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
      },
    },
    stroke: {
      width: 1,
    },
    tooltip: {
      x: {
        show: false,
      },
      y: {
        formatter: function (value, config) {
          return config.globals.seriesNames[config.dataPointIndex];
        },
        title: {
          formatter: (seriesName) => {
            return '';
          },
        },
      },
    },
    labels: speciesList,
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      '#231B56',
      '#493E8B',
      '#C1B8D7',
      '#F1B480',
      '#F2D5B5',
      '#D18543',
      '#7D86D9',
    ],
  };

  return (
    <div id="pie-chart" className="pie-chart">
      <Box sx={{ display: 'flex' }}>
        <ReactApexChart
          type="pie"
          options={options}
          series={speciesPercentage}
          width={500}
        />
        <PieChartLegendTable
          species={currentSelectedSpecies}
          rows={props.rows}
        />
      </Box>
    </div>
  );
}
